import { fetchAPI } from "../../../../config/axios";
import {
  PemantauanKRIAction,
  PemantauanKRIActionType,
  PemantauanKRIModel,
} from "./types";

export const PemantauanKRIRegisterDefault: PemantauanKRIModel = {
  pemantauanMain: {
    data: [],
    total: 0,
  },
  pemantauanIRUMain: {
    data: [],
    total: 0,
  },
  detailPemantauan: {},
};

export const PemantauanKRIRegisterReducer = (
  state: PemantauanKRIModel = PemantauanKRIRegisterDefault,
  action: PemantauanKRIAction
): PemantauanKRIModel => {
  switch (action.type) {
    case PemantauanKRIActionType.GetPemantauanKRI:
      return { ...state, pemantauanMain: action.data };
    case PemantauanKRIActionType.GetDetailPemantauanKRI:
      return { ...state, detailPemantauan: action.data };
    case PemantauanKRIActionType.GetPemantauanIRU:
      return { ...state, pemantauanIRUMain: action.data };
    default:
      return state;
  }
};

export const PemantauanKRIRegisterCommand = {
  GetPemantauanRisikoUtama: (params: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().get("/tj-kri-registers", { params });
        dispatch({
          type: PemantauanKRIActionType.GetPemantauanKRI,
          data: {
            data: response.data.data.data,
            total: response.data.data.total,
          },
        });
      } catch (error) {
        throw error;
      }
    };
  },
  GetPemantauanIRU: (params: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().get("/tj-kri-penanganan-irus", { params });
        dispatch({
          type: PemantauanKRIActionType.GetPemantauanIRU,
          data: {
            data: response.data.data.data,
            total: response.data.data.total,
          },
        });
      } catch (error) {
        throw error;
      }
    };
  },
  ApprovalPenangananRisikoUtama: (body: any) => {
    return async (dispatch: any) => {
      try {
        const url = body.type ==="approve" ? "/tj-kri-penanganan/submit" : "/tj-kri-penanganan/reject"
        const response = await fetchAPI().post(url,
            body.body
        );
        return response
      } catch (error) {
        throw error;
      }
    };
  },
  SendEmailPenangananRisikoUtama: (body: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().post(
          "/tj-send-email",
            body
        );
        return response
      } catch (error) {
        throw error;
      }
    };
  },
  GetDetailPemantauanRisikoUtama: (params: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().get("/tj-kri-penanganan", { params });
        dispatch({
          type: PemantauanKRIActionType.GetDetailPemantauanKRI,
          data: response.data.data,
        });
      } catch (error) {
        throw error;
      }
    };
  },
  CreatePemantauanRisikoUtama: (body: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().post("/tj-kri-penanganan", body);
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  CreatePemantauanIRU: (body: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().post("/tj-kri-penanganan-iru", body);
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
};
